module.exports = __webpack_public_path__ + "img/Feature.77c2a103.jpg";